import React from 'react';
import styles from './Steps.module.css';
import Fade from 'react-reveal/Fade';
import ParamButton from '../ui/ParamButton';

const HeadToasting = (props) => {
    const { step, param, setParam, backgroundColor } = props;

    const infos = [
        {value: 'YES'},
        {value: 'NO'},
    ];

    return (
        <div id={styles.container}>
            <p id={styles.step}>{'0' + step}</p>
            <p id={styles.title}>HEAD TOASTING</p>

            {infos.map((info, key) => (
                <Fade key={key} delay={300 + key * 100}>
                    <ParamButton
                        style={param === info.value ? {backgroundColor: 'white', color: '#BF7931'} : null}
                        backgroundColor={backgroundColor}
                        text={info.value}
                        info={info.info}
                        selected={param === info.value}
                        onPress={() => setParam('headToasting', info.value)}
                    />
                </Fade>
            ))}
        </div>
    );
};

export default HeadToasting;
